class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// FUNCIÓN ÚNICA Y SIMPLIFICADA: Solo actualizar contador del carrito - CON DEBOUNCE MEJORADO
let updateCartTimeout = null;
function updateCartCounter(newCount) {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;
  
  const hasItems = newCount && newCount !== '0';
  const currentCount = cartIcon.dataset.cartCount || '0';
  
  // Asegurar que el icono tiene la estructura básica correcta PRIMERO
  ensureCartIconStructure(cartIcon);
  
  // Cancelar cualquier actualización pendiente para evitar conflictos
  if (updateCartTimeout) {
    clearTimeout(updateCartTimeout);
  }
  
  // Actualizar inmediatamente si es un cambio válido
  if (currentCount !== String(newCount)) {
    // Actualizar solo la burbuja, NUNCA el icono completo
    updateCartBubbleOnly(cartIcon, newCount, hasItems);
    
    // Actualizar el data attribute
    cartIcon.dataset.cartCount = String(newCount);
    
    // Programar una verificación adicional para asegurar consistencia
    updateCartTimeout = setTimeout(() => {
      const bubble = cartIcon.querySelector('.cart-count-bubble');
      if (hasItems && !bubble) {
        // Si debería haber burbuja pero no existe, crearla
        updateCartBubbleOnly(cartIcon, newCount, hasItems);
      } else if (!hasItems && bubble && bubble.style.display !== 'none') {
        // Si no debería haber burbuja pero existe y está visible, ocultarla
        updateCartBubbleOnly(cartIcon, newCount, hasItems);
      }
      updateCartTimeout = null;
    }, 500);
  }
}

// Función para asegurar estructura básica del icono (solo si está roto)
function ensureCartIconStructure(cartIcon) {
  const hasSvg = cartIcon.querySelector('svg');
  const hasCorrectSvg = cartIcon.querySelector('svg path[d*="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"]');
  
  // Solo recrear si NO hay SVG o es incorrecto
  if (!hasSvg || !hasCorrectSvg) {
    // Preservar TODAS las propiedades críticas para evitar flash
    const computedStyle = window.getComputedStyle(cartIcon);
    const currentClasses = cartIcon.className;
    const currentStyles = {
      width: computedStyle.width,
      height: computedStyle.height,
      minWidth: computedStyle.minWidth,
      minHeight: computedStyle.minHeight,
      maxWidth: computedStyle.maxWidth,
      maxHeight: computedStyle.maxHeight,
      display: computedStyle.display,
      position: computedStyle.position,
      flexShrink: computedStyle.flexShrink,
      flexGrow: computedStyle.flexGrow,
      boxSizing: computedStyle.boxSizing
    };
    
    // Crear el nuevo innerHTML SIN cambiar nada más
    cartIcon.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <path d="M16 10a4 4 0 0 1-8 0"></path>
      </svg>
      <span class="visually-hidden">Shopping cart</span>
    `;
    
    // Restaurar TODO inmediatamente para evitar cualquier flash
    cartIcon.className = currentClasses;
    Object.assign(cartIcon.style, currentStyles);
      // Forzar estilos críticos adicionales - TAMAÑO UNIFORME
    cartIcon.style.width = '4rem';
    cartIcon.style.height = '4rem';
    cartIcon.style.minWidth = '4rem';
    cartIcon.style.minHeight = '4rem';
    cartIcon.style.maxWidth = '4rem';
    cartIcon.style.maxHeight = '4rem';
    cartIcon.style.display = 'flex';
    cartIcon.style.alignItems = 'center';
    cartIcon.style.justifyContent = 'center';
    cartIcon.style.flexShrink = '0';
    cartIcon.style.flexGrow = '0';
    cartIcon.style.position = 'relative';
    cartIcon.style.boxSizing = 'border-box';
    cartIcon.style.transform = 'translateZ(0)';
    cartIcon.style.backfaceVisibility = 'hidden';
    cartIcon.style.contain = 'layout style';
  }
}

// Función para actualizar SOLO la burbuja del contador - MEJORADA ANTI-DESAPARICIÓN
function updateCartBubbleOnly(cartIcon, newCount, hasItems) {
  let bubble = cartIcon.querySelector('.cart-count-bubble');
  
  // Cancelar cualquier timeout pendiente de eliminación
  if (bubble && bubble.removeTimeout) {
    clearTimeout(bubble.removeTimeout);
    bubble.removeTimeout = null;
  }
  
  if (hasItems) {
    if (!bubble) {
      // Crear nueva burbuja con animación suave
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true">${newCount}</span>
        <span class="visually-hidden">Cart count: ${newCount}</span>
      `;
      
      // Iniciar invisible para animación
      bubble.style.transform = 'scale(0)';
      bubble.style.opacity = '0';
      bubble.style.visibility = 'visible';
      bubble.style.display = 'flex';
      
      cartIcon.appendChild(bubble);
      
      // Animar entrada
      requestAnimationFrame(() => {
        bubble.style.transition = 'transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.2s ease';
        bubble.style.transform = 'scale(1)';
        bubble.style.opacity = '1';
      });
      
    } else {
      // Actualizar burbuja existente
      const countSpan = bubble.querySelector('span[aria-hidden="true"]');
      const hiddenSpan = bubble.querySelector('.visually-hidden');
      
      // Asegurar que la burbuja esté visible
      bubble.style.display = 'flex';
      bubble.style.visibility = 'visible';
      bubble.style.opacity = '1';
      bubble.style.transform = 'scale(1)';
      
      if (countSpan && countSpan.textContent !== String(newCount)) {
        // Animación suave de cambio de número
        countSpan.style.transition = 'transform 0.15s ease';
        countSpan.style.transform = 'scale(1.1)';
        
        setTimeout(() => {
          countSpan.textContent = newCount;
          countSpan.style.transform = 'scale(1)';
        }, 75);
      }
      
      if (hiddenSpan) {
        hiddenSpan.textContent = `Cart count: ${newCount}`;
      }
    }
  } else {
    // Ocultar burbuja si no hay items - CON RETRASO PARA EVITAR PARPADEO
    if (bubble) {
      bubble.style.transition = 'transform 0.2s ease, opacity 0.2s ease';
      bubble.style.transform = 'scale(0)';
      bubble.style.opacity = '0';
      
      // Usar timeout con referencia para poder cancelarlo
      bubble.removeTimeout = setTimeout(() => {
        if (bubble && bubble.parentNode) {
          bubble.style.display = 'none';
          bubble.style.visibility = 'hidden';
        }
        bubble.removeTimeout = null;
      }, 300); // Aumentado el tiempo para evitar parpadeo
    }
  }
}

// Función legacy para compatibilidad (redirige a la nueva función)
function restorePiraCartIcon() {
  const cartCount = getCartCount();
  updateCartCounter(cartCount);
}

// Función legacy adicional para compatibilidad
function updateCartCounterOnly(newCount) {
  updateCartCounter(newCount);
  
  // Update data attribute
  cartIcon.dataset.cartCount = newCount;
  
  console.log(`Cart counter updated: ${currentCount} → ${newCount}`);
}

// Function to clean up unwanted text in cart icon
function cleanCartIconText() {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;
  
  // Remove any duplicate or unwanted text nodes that aren't in proper containers
  const walker = document.createTreeWalker(
    cartIcon,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  
  const textNodes = [];
  let node;
  while (node = walker.nextNode()) {
    // Skip text nodes that are properly contained in spans
    const parentElement = node.parentElement;
    const isInProperContainer = parentElement && (
      parentElement.classList.contains('visually-hidden') ||
      parentElement.closest('.visually-hidden') ||
      parentElement.hasAttribute('aria-hidden') ||
      parentElement.closest('.cart-count-bubble')
    );
    
    if (!isInProperContainer && node.textContent.trim()) {
      textNodes.push(node);
    }
  }
  
  // Remove unwanted text nodes (loose text that shouldn't be there)
  textNodes.forEach(textNode => {
    const text = textNode.textContent.trim();
    // Remove any loose text that contains words or numbers not in proper containers
    if (text.match(/artículos|items|producto|cart|count/i) || 
        (text.length > 0 && textNode.parentElement === cartIcon)) {
      textNode.textContent = '';
    }
  });
  
  // Additional cleanup: ensure no duplicate numbers in aria-hidden spans
  const cartBubble = cartIcon.querySelector('.cart-count-bubble');
  if (cartBubble) {
    const ariaHiddenSpans = cartBubble.querySelectorAll('span[aria-hidden="true"]');
    // Keep only the first aria-hidden span, remove duplicates
    if (ariaHiddenSpans.length > 1) {
      for (let i = 1; i < ariaHiddenSpans.length; i++) {
        ariaHiddenSpans[i].remove();
      }
    }
  }
}

// Override the original renderContents method to restore our icon with better cart count handling
const originalCartNotification = customElements.get('cart-notification');
if (originalCartNotification) {
  const originalRenderContents = originalCartNotification.prototype.renderContents;

  originalCartNotification.prototype.renderContents = function (parsedState) {
    // Store the cart count from the parsed state if available
    if (parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
      // Extract cart count from the section HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = parsedState.sections['cart-icon-bubble'];
      const countElement = tempDiv.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (countElement) {
        const count = countElement.textContent.trim();
        // Store in global scope for our functions to use
        if (window.theme) {
          window.theme.cartCount = parseInt(count) || 0;
        } else {
          window.theme = { cartCount: parseInt(count) || 0 };
        }
      }
    }

    // Call the original method first
    originalRenderContents.call(this, parsedState);    // Then restore our custom cart icon with correct count
    setTimeout(() => {
      const currentCount = getCartCount();
      queueCartUpdate(currentCount);
      cleanCartIconText();
    }, 50);
  };
}

// Initialize on page load - OPTIMIZADO ANTI-FOUC
document.addEventListener('DOMContentLoaded', () => {
  // Aplicar estilos inmediatamente para evitar FOUC
  applyAntiFlashStyles();
  
  // Initial restoration con delay mínimo - usar función suave si es posible
  setTimeout(() => {
    const cartIcon = document.getElementById('cart-icon-bubble');    if (cartIcon && cartIcon.querySelector('svg')) {
      // Icon structure exists, just update counter
      const initialCount = getCartCount();
      updateCartCounter(initialCount);
    } else {
      // Icon needs complete setup
      updateCartCounter(getCartCount());
    }
    cleanCartIconText();
  }, 10);
  
  // Set up duplication prevention
  preventCartDuplication();
  
  // Store initial cart count if available
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    const initialCount = getCartCount();
    cartIcon.dataset.cartCount = initialCount;
  }
  
  // Setup cart page listeners for quantity changes and removals
  setupCartPageListeners();
});

// Función para aplicar estilos anti-flash inmediatamente
function applyAntiFlashStyles() {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    // Aplicar estilos de tamaño inmediatamente - TAMAÑO UNIFORME
    cartIcon.style.width = '4rem';
    cartIcon.style.height = '4rem';
    cartIcon.style.minWidth = '4rem';
    cartIcon.style.minHeight = '4rem';
    cartIcon.style.maxWidth = '4rem';
    cartIcon.style.maxHeight = '4rem';
    cartIcon.style.display = 'flex';
    cartIcon.style.alignItems = 'center';
    cartIcon.style.justifyContent = 'center';
    cartIcon.style.flexShrink = '0';
    cartIcon.style.flexGrow = '0';
    cartIcon.style.boxSizing = 'border-box';
    cartIcon.style.position = 'relative';
    
    // Asegurar clases correctas
    if (!cartIcon.classList.contains('pira-header__icon')) {
      cartIcon.classList.add('pira-header__icon');
    }
    if (!cartIcon.classList.contains('pira-header__cart')) {
      cartIcon.classList.add('pira-header__cart');
    }
  }
  
  // Aplicar estilos a todos los iconos del header - TAMAÑO UNIFORME
  const headerIcons = document.querySelectorAll('.pira-header__icon');
  headerIcons.forEach(icon => {
    icon.style.width = '4rem';
    icon.style.height = '4rem';
    icon.style.minWidth = '4rem';
    icon.style.minHeight = '4rem';
    icon.style.flexShrink = '0';
    icon.style.flexGrow = '0';
    icon.style.boxSizing = 'border-box';
  });
}

// Function to setup listeners specifically for the cart page
function setupCartPageListeners() {
  // Check if we're on the cart page
  if (!window.location.pathname.includes('/cart')) return;
  
  console.log('Setting up cart page listeners');
  
  // Listen for quantity input changes
  const quantityInputs = document.querySelectorAll('quantity-input input[type="number"]');
  quantityInputs.forEach(input => {
    input.addEventListener('change', debounce(() => {
      console.log('Quantity changed, updating cart counter');
      setTimeout(() => {
        fetchCartCountAndUpdate();
      }, 500); // Wait a bit for the cart to update
    }, 300));
  });
  
  // Listen for remove button clicks
  const removeButtons = document.querySelectorAll('cart-remove-button button');
  removeButtons.forEach(button => {
    button.addEventListener('click', () => {
      console.log('Remove button clicked, updating cart counter');
      setTimeout(() => {
        fetchCartCountAndUpdate();
      }, 1000); // Wait longer for removal to complete
    });
  });
  
  // Setup mutation observer to detect when cart items are added/removed from DOM
  const cartItemsContainer = document.querySelector('#main-cart-items');
  if (cartItemsContainer) {
    const observer = new MutationObserver(debounce((mutations) => {
      const hasItemChanges = mutations.some(mutation => 
        mutation.type === 'childList' && 
        (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
      );
      
      if (hasItemChanges) {
        console.log('Cart items DOM changed, updating counter');
        setTimeout(() => {
          fetchCartCountAndUpdate();
        }, 500);
      }
    }, 300));
    
    observer.observe(cartItemsContainer, {
      childList: true,
      subtree: true
    });
  }
  
  // Listen for form submissions (cart updates)
  const cartForm = document.querySelector('form[action*="cart"]');
  if (cartForm) {
    cartForm.addEventListener('submit', () => {
      console.log('Cart form submitted, updating counter');
      setTimeout(() => {
        fetchCartCountAndUpdate();
      }, 1000);
    });
  }
    // Periodically check cart count when on cart page (fallback)
  const cartPageInterval = setInterval(() => {
    if (!window.location.pathname.includes('/cart')) {
      clearInterval(cartPageInterval);
      return;
    }
    fetchCartCountAndUpdate();
  }, 3000); // Check every 3 seconds
  
  // Listen for any input changes on the cart page
  document.addEventListener('input', (event) => {
    if (event.target.matches('quantity-input input[type="number"]') ||
        event.target.closest('quantity-input')) {
      console.log('Quantity input changed');
      setTimeout(() => {
        fetchCartCountAndUpdate();
      }, 500);
    }
  });
  
  // Listen for any button clicks that might affect cart
  document.addEventListener('click', (event) => {
    if (event.target.matches('cart-remove-button button') ||
        event.target.closest('cart-remove-button') ||
        event.target.matches('[data-cart-action]') ||
        event.target.closest('[data-cart-action]')) {
      console.log('Cart action button clicked');
      setTimeout(() => {
        fetchCartCountAndUpdate();
      }, 1000);
    }
  });
}

// Function to fetch cart count from Shopify's cart API - OPTIMIZADO CON COLA
async function fetchCartCountAndUpdate() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const newCount = cart.item_count.toString();
    
    // Update global cart state if available
    if (window.Shopify && window.Shopify.cart) {
      window.Shopify.cart.item_count = cart.item_count;
    }
    if (window.theme) {
      window.theme.cartCount = newCount;
    }
    
    // Use the queue system for smooth updates during rapid changes
    queueCartUpdate(newCount);
    
    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { item_count: cart.item_count }
    }));
  } catch (error) {
    console.error('Error fetching cart count:', error);
    // Fallback to complete restoration only on error
    const fallbackCount = getCartCount();
    queueCartUpdate(fallbackCount);
  }
}

// Debounce utility function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Enhanced listeners to catch cart updates from various sources - OPTIMIZADO
document.addEventListener('cart:updated', () => {
  // Usar la nueva función optimizada con cola
  debounceCartUpdate(() => {
    const newCount = getCartCount();
    queueCartUpdate(newCount);
    cleanCartIconText();
  });
});

document.addEventListener('variant:change', () => {
  debounceCartUpdate(() => {
    const newCount = getCartCount();
    queueCartUpdate(newCount);
    cleanCartIconText();
  });
});

// Listen for Shopify's native cart update events
document.addEventListener('cart:build', () => {
  debounceCartUpdate(() => {
    const newCount = getCartCount();
    queueCartUpdate(newCount);
    cleanCartIconText();
  });
});

// Debounce específico para actualizaciones del carrito (más agresivo)
let cartUpdateTimeout;
function debounceCartUpdate(func) {
  clearTimeout(cartUpdateTimeout);
  cartUpdateTimeout = setTimeout(func, 50); // Delay más corto para mejor UX
}

// Listen for any form submissions on cart page
document.addEventListener('submit', (event) => {
  if (event.target.matches('form[action*="/cart"]') || 
      event.target.closest('form[action*="/cart"]')) {
    console.log('Cart form submitted, scheduling update');
    setTimeout(() => {
      fetchCartCountAndUpdate();
    }, 1000);
  }
});

// Listen for AJAX requests that might update the cart
const originalFetch = window.fetch;
window.fetch = function(...args) {
  const url = args[0];
  if (typeof url === 'string' && (url.includes('/cart') || url.includes('cart.js'))) {
    console.log('Cart API call detected:', url);
    return originalFetch.apply(this, args).then(response => {
      if (response.ok) {
        setTimeout(() => {
          fetchCartCountAndUpdate();
        }, 500);
      }
      return response;
    });
  }
  return originalFetch.apply(this, args);
};

// Enhanced mutation observer to watch for changes to the cart icon
const cartIcon = document.getElementById('cart-icon-bubble');
if (cartIcon) {
  const observer = new MutationObserver(function(mutations) {
    let needsRestore = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        // Check if the icon was changed to a different structure
        const svgWrapper = cartIcon.querySelector('.svg-wrapper svg');
        const hasCorrectIcon = svgWrapper && svgWrapper.querySelector('path[d*="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"]');
        
        if (!hasCorrectIcon) {
          needsRestore = true;
        }
        
        // Check for duplicate bubbles or text
        const bubbles = cartIcon.querySelectorAll('.cart-count-bubble');
        if (bubbles.length > 1) {
          needsRestore = true;
        }
      }
    });
      if (needsRestore) {
      // Debounced restore to avoid excessive calls
      clearTimeout(observer.restoreTimeout);
      observer.restoreTimeout = setTimeout(() => {
        const currentCount = getCartCount();
        updateCartCounter(currentCount);
        cleanCartIconText();
      }, 100);
    }
  });
  
  observer.observe(cartIcon, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-cart-count']
  });
}

// Function to get cart count from multiple reliable sources
function getCartCount() {
  // Try to get from Shopify's global cart object first
  if (window.Shopify && window.Shopify.cart && typeof window.Shopify.cart.item_count !== 'undefined') {
    return window.Shopify.cart.item_count.toString();
  }
  
  // Try to get from theme's cart count
  if (window.theme && typeof window.theme.cartCount !== 'undefined') {
    return window.theme.cartCount.toString();
  }
  
  // Try to get from data attributes
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon && cartIcon.dataset.cartCount) {
    return cartIcon.dataset.cartCount;
  }
  
  // If we're on the cart page, count items in the DOM
  if (window.location.pathname.includes('/cart')) {
    const cartItems = document.querySelectorAll('.cart-item');
    if (cartItems.length === 0) {
      return '0';
    }
    
    // Count total quantity from all items
    let totalCount = 0;
    cartItems.forEach(item => {
      const quantityInput = item.querySelector('quantity-input input[type="number"]');
      if (quantityInput && quantityInput.value) {
        totalCount += parseInt(quantityInput.value) || 0;
      }
    });
    
    if (totalCount > 0) {
      return totalCount.toString();
    }
  }
  
  // Fallback: try to get from existing bubble (more safely)
  const existingBubble = cartIcon?.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  if (existingBubble) {
    const count = existingBubble.textContent.trim().replace(/\D/g, '');
    return count;
  }
  
  return '0';
}

// Prevent cart count duplication by intercepting DOM mutations
function preventCartDuplication() {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;

  const observer = new MutationObserver(function(mutations) {
    let shouldRestore = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if multiple cart count bubbles were added
        const bubbles = cartIcon.querySelectorAll('.cart-count-bubble');
        if (bubbles.length > 1) {
          // Remove all but the first bubble
          for (let i = 1; i < bubbles.length; i++) {
            bubbles[i].remove();
          }
          shouldRestore = true;
        }
        
        // Check for duplicate aria-hidden spans
        const ariaSpans = cartIcon.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
        if (ariaSpans.length > 1) {
          for (let i = 1; i < ariaSpans.length; i++) {
            ariaSpans[i].remove();
          }
          shouldRestore = true;
        }
      }
      
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        // Check for number duplication in text content
        const bubble = cartIcon.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (bubble) {
          const text = bubble.textContent;
          // Check if the text contains repeated numbers (like "22" when it should be "2")
          if (text.length > 1 && text.match(/(\d)\1+/)) {
            const cleanNumber = text.charAt(0); // Take only the first digit
            if (cleanNumber !== text) {
              bubble.textContent = cleanNumber;
              // Also update the visually-hidden span
              const hiddenSpan = cartIcon.querySelector('.cart-count-bubble .visually-hidden');
              if (hiddenSpan) {
                hiddenSpan.textContent = `Cart count: ${cleanNumber}`;
              }
            }
          }
        }
      }
    });
    
    if (shouldRestore) {
      // Debounce the restore function
      clearTimeout(preventCartDuplication.restoreTimeout);
      preventCartDuplication.restoreTimeout = setTimeout(() => {
        cleanCartIconText();
      }, 50);
    }
  });
  
  observer.observe(cartIcon, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: false
  });
  
  return observer;
}

// Sistema mejorado para manejar cambios rápidos múltiples
let cartUpdateQueue = [];
let isProcessingQueue = false;

function queueCartUpdate(newCount) {
  cartUpdateQueue.push(newCount);
  processCartUpdateQueue();
}

function processCartUpdateQueue() {
  if (isProcessingQueue || cartUpdateQueue.length === 0) return;
  
  isProcessingQueue = true;
  
  // Obtener el último valor de la cola (el más reciente)
  const latestCount = cartUpdateQueue[cartUpdateQueue.length - 1];
  cartUpdateQueue = []; // Limpiar la cola
  
  // Aplicar la actualización
  updateCartCounter(latestCount);
  
  // Esperar un poco antes de procesar la siguiente actualización
  setTimeout(() => {
    isProcessingQueue = false;
    if (cartUpdateQueue.length > 0) {
      processCartUpdateQueue();
    }
  }, 100);
}
